import React from 'react';
import TheHeading from './TheHeading';
import SectionAbout from './SectionAbout';
import SectionReferences from './SectionReferences';

import '../css/App.scss';

function App() {
    return (
      <div className="content">
	    	<TheHeading />
	    	<div className="content__main">
	    		<SectionAbout />
	    		<SectionReferences />
	    	</div>
	    </div>
    );
}

export default App;